"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RX_PHONE_PREFIXES = exports.RX_PHONES = exports.RX_PASSWORD = exports.RX_IDENTITY = exports.RX_EMAIL = exports.RX_ALPHA = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// RegExp
var RX_ALPHA = exports.RX_ALPHA = '^[a-zA-Z]+$';
var RX_EMAIL = exports.RX_EMAIL = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var RX_PASSWORD = exports.RX_PASSWORD = ['^', '(?=.*\\d)',
// one number
'(?=.*[a-zA-Z])',
// one alphabet
'[A-Za-z\\d\\:\\;\\"\\\'\\+\\=\\-\\_\\\\\\|\\{\\[\\}\\]\\<\\>\\.\\,\\/\\?\\|', '\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)]', '{6,}',
// 6 characters
'$'].join('');
var RX_PHONE_PREFIXES = exports.RX_PHONE_PREFIXES = {
  IN: '^62$',
  MY: '^60$',
  SG: '^65$'
};

// Complicated RegExp
// use String(62) to avoid `Non-string literal property keys not supported` warning
var RX_PHONES = exports.RX_PHONES = _defineProperty(_defineProperty(_defineProperty({}, String(62), {
  // indonesia
  "false": '^[2-9]\\d{10,}$',
  "true": '^08\\d{9,10}$'
}), String(60), {
  // malaysia
  "false": '^[2-9]\\d{7,8}$',
  "true": '^1\\d{8,9}$'
}), String(65), {
  // singapore
  "false": '^[6]\\d{7}$',
  "true": '^[89]\\d{7}$'
});
var RX_IDENTITY = exports.RX_IDENTITY = {
  MY: {
    ic_number: '^([0-9][0-9])((0[1-9])|(1[0-2]))((0[1-9]|[1-2][0-9]|3[0-1]))([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^[a-zA-Z0-9 ()-]{0,30}$'
  },
  ID: {
    ic_number: '^(1[1-9]|21|3[1-6]|5[1-3]|6[1-5]|7[1-6]|8[1-2]|9[1-2])([0-2][0-9]|7[0-9])([0-9][0-9])(0[1-9]|1[1-9]|2[1-9]|3[0-1]|4[1-9]|5[1-9]|6[1-9]|7[0-1])(0[1-9]|1[1-2])([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^\\w*$'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/constants/index.js
// module id = 172
// module chunks = 0